import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FilterSearchingBaseViewModel, Tc } from 'src/app/components/core/_infrastructure/types/common';
import { PermisosAccionesImpresosIyIIIService } from '../permisosaccionesimpresosIyIII.service';
import {
    FilterSearchingPermisosAccionesImpresosIyIIIViewModel,
    PermisosAccionesImpresosIyIIIItemResultsViewModel,
} from '../permisosaccionesimpresosIyIII.types';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { ConfirmationService } from 'primeng/api';
import { EnumIdsTcTipoModulo } from '../../../../_importacion/solicitudes/types/enum';

@Component({
    selector: 'app-permisosaccionesimpresosiyiii-wrapper',
    templateUrl: './permisosaccionesimpresosiyiii-wrapper.component.html',
})
export class PermisosAccionesImpresosIyIIIWrapperComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    searching = false;
    result: PermisosAccionesImpresosIyIIIItemResultsViewModel | null;
    payload?: FilterSearchingPermisosAccionesImpresosIyIIIViewModel;
    edition = false;

    listAcciones: Tc[];
    listPerfiles: Tc[];
    listEstadosImpresosIyIII: Tc[];

    idModuloImpresosIyIII = EnumIdsTcTipoModulo.ID_IMPRESOS_I_III;

    constructor(
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private permisosAccionesImpresosIyIIIService: PermisosAccionesImpresosIyIIIService,
        private router: Router,
        private confirmationService: ConfirmationService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit(): void {
        this.recoverLastSearch();

        this.permisosAccionesImpresosIyIIIService.getAcciones(this.idModuloImpresosIyIII).subscribe(params => {
            this.listAcciones = params;
        });

        this.permisosAccionesImpresosIyIIIService.getPerfiles().subscribe(params => {
            this.listPerfiles = params;
        });

        this.permisosAccionesImpresosIyIIIService.getEstadosImpresosIyIII().subscribe(params => {
            this.listEstadosImpresosIyIII = params;
        });
    }

    onSearch(payload: FilterSearchingPermisosAccionesImpresosIyIIIViewModel): void {
        if (!payload) {
            return;
        }

        this.result = null;

        this.payload = { ...payload } as FilterSearchingPermisosAccionesImpresosIyIIIViewModel; // To keep a copy to be used in the lazy search (paginator)

        this.permisosAccionesImpresosIyIIIService.getPermisosAccionesImpresosIyIII(payload).subscribe(results => {
            this.result = results;
            this.searching = true;
        });
    }

    onSearchLazy(lazyLoadParams: FilterSearchingBaseViewModel): void {
        const payload = {
            ...this.payload,
            PageNumber: lazyLoadParams.PageNumber,
            Asc: lazyLoadParams.Asc,
            OrderBy: lazyLoadParams.OrderBy,
        } as FilterSearchingPermisosAccionesImpresosIyIIIViewModel;
        this.onSearch(payload);
    }

    onReset(): void {
        this.searching = false;
        this.result = null;
        this.permisosAccionesImpresosIyIIIService.clearLastSearch();
    }

    onAdd(): void {
        this.edition = true;
        this.router.navigate(['/mantenimiento/permisos/permisosaccionesimpresosiyiii/create']);
    }

    onDelete(id: number): void {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                this.permisosAccionesImpresosIyIIIService.deletePermisoAccionImpresosIyIII(id).subscribe({
                    next: () => {
                        this.addSuccessMessage('Permiso Acción eliminado correctamente');
                        this.recoverLastSearch();
                        this.onSearch(this.payload!);
                    },
                    error: error => {
                        this.catchServerError(error);
                    },
                });
            },
        });
    }

    private recoverLastSearch() {
        this.payload = this.permisosAccionesImpresosIyIIIService.getLastSearch();
    }

    onExportExcel(): void {
        this.visibilitySpinner = true;

        let model: FilterSearchingPermisosAccionesImpresosIyIIIViewModel = new FilterSearchingPermisosAccionesImpresosIyIIIViewModel();
        Object.assign(model, this.payload);

        this.permisosAccionesImpresosIyIIIService.export(model).subscribe(res => {
            this.OpenDownloadedFile(res);
            this.visibilitySpinner = false;
        });
    }

    exportIsAvailable(): boolean {
        return this.result?.ResultList ? this.result?.ResultList?.length > 0 : false;
    }
}
